function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import escape from 'lodash/escape';
import markdown from '@cloudflare/util-markdown';
import { I18n } from './i18nContext';
const tagRegex = /<(\d+)>(.*)<\/\1>|<(\d+)\/>/;
const newLineRegex = /(?:\r\n|\r|\n)/g;

function objectKeys(t) {
  return Object.keys(t);
}

function createElement(index, value) {
  return /*#__PURE__*/React.createElement("span", {
    key: index,
    dangerouslySetInnerHTML: {
      __html: value
    }
  });
}
/**
 * `formatElements` - parse string and return tree of react elements
 *
 * `value` is string to be formatted with <0>Paired<0/> or <0/> (unpaired)
 * placeholders. `Components` is a array of react Components which indexes
 * correspond to element indexes in formatted string
 */


function formatElements(value, Components = [], componentProps = []) {
  // TODO: warn if there are any unprocessed elements
  // TODO: warn if element at `index` doesn't exist
  let treeIndex = 0;
  const parts = value.replace(newLineRegex, '').split(tagRegex); // If there are no inline elements, return value

  if (parts.length === 1) return [createElement(treeIndex, value)];
  const tree = [];
  const before = parts.shift();

  if (before) {
    const element = createElement(treeIndex, before);
    tree.push(element);

    if (typeof element !== 'string') {
      treeIndex++;
    }
  }

  for (const _ref of getElements(parts)) {
    var _ref2 = _slicedToArray(_ref, 3);

    const index = _ref2[0];
    const children = _ref2[1];
    const after = _ref2[2];

    if (!Components[index]) {
      window.console && console.warn(`Missing Component for translation key: ${value}, index: ${index}. Fragment will be used.`);
    }

    const Component = Components[index] || React.Fragment;
    const props = componentProps[index] || {};
    const element = createElement(0, children);
    tree.push( /*#__PURE__*/React.createElement(Component, _extends({
      key: treeIndex
    }, props), element));
    treeIndex++;

    if (after) {
      const element = createElement(treeIndex, after);
      tree.push(element);

      if (typeof element !== 'string') {
        treeIndex++;
      }
    }
  }

  return tree;
}

/*
 * `getElements` - return array of element indexes and element childrens
 *
 * `parts` is array of [pairedIndex, children, unpairedIndex, textAfter, ...]
 * where:
 * - `pairedIndex` is index of paired element (undef for unpaired)
 * - `children` are children of paired element (undef for unpaired)
 * - `unpairedIndex` is index of unpaired element (undef for paired)
 * - `textAfter` is string after all elements (empty string, if there's nothing)
 *
 * `parts` length is always multiply of 4
 *
 * Returns: Array<[elementIndex, children, after]>
 */
function getElements(parts) {
  if (!parts.length) return [];

  const _parts$slice = parts.slice(0, 4),
        _parts$slice2 = _slicedToArray(_parts$slice, 4),
        paired = _parts$slice2[0],
        children = _parts$slice2[1],
        unpaired = _parts$slice2[2],
        after = _parts$slice2[3];

  const element = [[parseInt(paired || unpaired), children || '', after]];
  return element.concat(getElements(parts.slice(4, parts.length)));
}

export function Trans({
  id = '',
  smartCount,
  _,
  values,
  applyMarkdown,
  Components,
  componentProps
}) {
  return /*#__PURE__*/React.createElement(I18n, null, translator => {
    // Ensure any interpolated values are escaped to prevent XSS and HTML injection
    if (values) {
      objectKeys(values).forEach(key => values[key] = escape(values[key]));
    } // Ensure any string props passed to React components are escaped to prevent potential XSS and HTML injection


    if (componentProps) {
      componentProps.forEach(props => {
        Object.keys(props).forEach(key => {
          if (typeof props[key] === 'string') {
            props[key] = escape(props[key]);
          }
        });
      });
    }

    const options = _objectSpread({
      smart_count: smartCount,
      _
    }, values); // Skip built-in markdown sanitization, as all inputs are already sanitized above
    // Having another round of sanitization here would strip all <0 /> component interpolation tags


    const text = applyMarkdown ? markdown(translator.t(id.toString(), options), {
      __dangerouslyDontSanitizeMarkdown: true
    }) : translator.t(id.toString(), options);
    const elements = formatElements(text, Components, componentProps);
    return elements.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, elements) : elements[0];
  });
}
export default Trans;